<template>
  <div>
    <div class="row mb-3 justify-content-end" v-show="services.length && isLoaded">
      <div class="col-md-6">
        <div class="d-flex align-items-center justify-content-end">
          <label for="serviceFilter" class="mb-0 mr-1">{{ $t('form.service') }}:</label>
          <treeselect :maxHeight="200"
              id="serviceFilter"
              v-model="service"
              :multiple="false"
              :options="services"
              :placeholder="$t('form.service')"
          />
        </div>
      </div>
    </div>
    <div v-if="isLoaded">
      <div v-cloak v-if="habilitations.length">
        <habilitationBox
          v-for="(habilitation, index) in habilitations"
          :key="index"
          :habilitation="habilitation"
          :index="index"
          :service="service"
          :services="services"
        />
      </div>

      <div v-cloak v-else>
        <div class="row">
          <div class="col-12">
            <div class="box-block">
              <div class="text-center">
                <div class="alert alert-primary">
                  {{ $t("emptyMonitoringList") }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div
        class="row d-flex justify-content-center align-items-center"
        style="min-height: 400px"
      >
        <div class="col-12">
          <div class="d-flex justify-content-center align-items-center">
            <div class="spinner-border" role="status">
              <span class="sr-only"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <registration-trainee-modal></registration-trainee-modal>
    <initial-trainee-modal></initial-trainee-modal>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import HabilitationBox from "./HabilitationBox.vue";
import RegistrationTraineeModal from "./modals/RecycleTraineeModal.vue";
import InitialTraineeModal from "./modals/InitialTraineeModal.vue";
import { mapFields } from "vuex-map-fields";
export default {
  name: "MyMonitoring",
  components: {
    HabilitationBox,
    RegistrationTraineeModal,
    InitialTraineeModal,
    Treeselect
  },
  data() {
    return {
      isLoaded: true,
      service: null,
      services: []
    };
  },
  computed: {
    ...mapFields(["monitoring.habilitations"]),
    ...mapFields(["user", "company", "establishment"])
  },
  mounted() {
    this.getHabilitations();
    this.$store.dispatch( 'monitoring/getServices', {  } ).then( ( resp ) => {
      this.services = resp.map( item => {
        return { id: item.key, label: item.value };
      } );
    } );
  },
  methods: {
    showFilterModal() {
      this.$bus.$emit( 'filter-monitoring-modal.show' );
    },
    getHabilitations() {
      this.isLoaded = false;
      let data = {
        clientId: this.user.id,
        companyId: this.$lodash.get(this.company, "id", null),
        establishmentId: this.$lodash.get(this.establishment, "id", null),
        service: this.service
      };
      this.$store
        .dispatch("monitoring/getHabilitations", data)
        .then(() => {})
        .finally(() => {
          this.isLoaded = true;
        });
    },
  },
  watch: {
    service() {
      this.getHabilitations();
    }
  }
};
</script>

<style></style>
